import Vue from 'vue'
import { Auth, isLoggedIn } from '@/_services/amplify.service.js'
import { routerHelpers } from '@/_helpers'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Login from './views/Login.vue'
import SignUp from './views/SignUp.vue'
import Verify from './views/Verify.js'
import BrowserDetect from './views/BrowserDetect.vue'
import InternalFleet from './views/fleet/InternalFleet.vue'
import ExternalFleet from './views/fleet/ExternalFleet.vue'
import Locations from './views/locations/Locations.vue'
import Orders from './views/orders/Orders.vue'
import ShipmentsRouter from './views/shipments/ShipmentsRouter.js'
import Reports from './views/reports/Reports.vue'
import OrdersReport from './views/reports/OrdersReport.vue'
import ShipmentsReport from './views/reports/ShipmentsReport.vue'
import Routes from './views/routes/Routes.vue'
import RoutesCreate from './views/routes/RoutesCreate.vue'
import CompaniesIndex from './views/companies/CompaniesIndex'
import CompanyDetail from './views/companies/CompanyDetail'
import CompanyForm from './views/companies/CompanyForm'
import Drops from './views/drops/Drops'
// import DropDetails from './views/drops/DropDetails'

import LocationDetail from '@/views/locations/LocationDetail'
import LocationDetail2 from '@/views/locations/LocationDetail2'
import LocationUpdate from '@/views/locations/LocationUpdate'
import LocationUpdate2 from '@/views/locations/LocationUpdate2'
import OrderDetail from '@/views/orders/OrderDetail'
import OrderUpdate from '@/views/orders/OrderUpdate.vue'
import VehicleDetail from '@/views/fleet/VehicleDetail'
import VehicleUpdate from '@/views/fleet/VehicleUpdate'
import Upload from '@/views/Upload'
import UserProfile from '@/views/users/UserProfile'

import Organizations from './views/organizations/Organizations'

import ShipmentsNew from './views/shipments/ShipmentsNew'
import ShipmentsGroupByDay from './views/shipments/ShipmentsGroupByDay'
import Maps from './views/maps/Maps.vue'
import ExampleCardsView from './views/cards/ExampleCardsView.vue'

import NotificationsNewsFeed from '@/views/notifications/NotificationsNewsFeed.vue'
import Planner from '@/views/shipments/planner/PlannerDrops.vue'

import TransportRequest from '@/views/orders/TransportRequest.vue'
import TransportRequestList from '@/views/orders/TransportRequestList.vue'

import TransportsForm from '@/views/orders/TransportsForm.vue'

import OrdersNew from '@/views/orders/OrdersNew.vue'
import Test from '@/views/Test.vue'
import MapForRoute from '@/views/maps/MapForRoute.vue'
import { getLoggedUser } from './_services/amplify.service'

Auth.configure({
  userPoolId: 'eu-west-1_TCDg9Hy3A',
  userPoolWebClientId: '3e4e53q4ll18rid1dkp044i1d7',
  region: 'eu-west-1',
  authenticationFlowType: 'USER_PASSWORD_AUTH'
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

Vue.use(Router)


const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
    props: { selectedView: 'overview' }
  },
  {
    path: '/test-detail',
    name: 'TestDetail',
    component: Test,
    props: { selectedView: 'detail' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: true
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
    props: true
  },
  {
    path: '/verify',
    name: 'Verify',
    component: Verify
  },
  {
    path: '/internal-fleet',
    name: 'InternalFleet',
    component: InternalFleet
  },
  {
    path: '/external-fleet',
    name: 'ExternalFleet',
    component: ExternalFleet
  },
  {
    path: '/vehicles/create',
    name: 'CreateVehicle',
    component: VehicleUpdate
  },
  {
    path: '/internal-fleet/:vehicleID/edit',
    name: 'VehicleUpdate',
    component: VehicleUpdate
  },
  {
    path: '/vehicles/:vehicleID',
    name: 'VehicleDetail',
    component: VehicleDetail
  },
  // TODO: after done locations, merge LocationDetail and LocationDetail2
  {
    path: '/companies/',
    name: 'CompaniesIndex',
    component: CompaniesIndex
  },
  {
    path: '/companies/create',
    name: 'CreateCompany',
    component: CompanyForm
  },
  {
    path: '/companies/:companyID/locations/',
    name: 'LocationCreate2',
    component: LocationUpdate2
  },
  {
    path: '/companies/:companyID/locations/:locationID',
    name: 'LocationDetail2',
    component: LocationDetail2
  },
  {
    path: '/companies/:companyID/locations/:locationID/edit',
    name: 'LocationEdit2',
    component: LocationUpdate2
  },
  {
    path: '/companies/:companyID/edit',
    name: 'EditCompany',
    component: CompanyForm
  },
  {
    path: '/companies/:companyID',
    name: 'CompanyDetail',
    component: CompanyDetail
  },
  {
    path: '/locations/',
    name: 'Locations',
    component: Locations
  },
  {
    path: '/locations/create',
    name: 'CreateLocation',
    component: LocationUpdate
  },
  {
    path: '/locations/:locationID/edit',
    name: 'EditLocation',
    component: LocationUpdate
  },
  {
    path: '/locations/:locationID',
    name: 'LocationDetail',
    component: LocationDetail
  },
  {
    path: '/orders-old/',
    name: 'Orders',
    component: Orders
  },
  {
    path: '/orders/create',
    name: 'CreateOrder',
    component: OrderUpdate
  },
  {
    path: '/orders/:orderID/edit',
    name: 'EditOrder',
    component: OrderUpdate
  },
  {
    path: '/transport-request/',
    name: 'TransportRequest',
    component: TransportRequestList
  },
  {
    path: '/transport-request/create',
    name: 'TransportRequestCreate',
    component: TransportRequest
  },
  {
    path: '/transport-request/:transportRequestID/detail',
    name: 'TransportRequestEdit',
    component: TransportRequest
  },
  {
    path: '/transports/create',
    name: 'TransportsCreate',
    component: TransportsForm
  },
  {
    path: '/transports/create',
    name: 'TransportsCreateNewShipment',
    component: TransportsForm,
    props: {
      isQuote: true
    }
  },
  {
    path: '/orders/:orderID',
    name: 'OrderDetail',
    component: OrderDetail
  },
  {
    path: '/maps',
    name: 'Maps',
    component: Maps
  },
  {
    path: '/test-cards',
    name: 'ExampleCardsView',
    component: ExampleCardsView
  },
  {
    path: '/routes',
    name: 'Routes',
    component: Routes
  },
  {
    path: '/routes-create',
    name: 'RoutesCreate',
    component: RoutesCreate
  },
  // {
  //   path: "/locations2",
  //   name: "Locations2",
  //   component: Locations2
  // },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports
  },
  {
    path: '/orders-report',
    name: 'OrdersReport',
    component: OrdersReport
  },
  {
    path: '/shipments-report',
    name: 'ShipmentsReport',
    component: ShipmentsReport
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload
  },
  {
    path: '/notificationsnewsfeed',
    name: 'Notifications News Feed',
    component: NotificationsNewsFeed
  },
  {
    path: '/planner*',
    name: 'Planner',
    component: Planner
  },
  {
    path: '/user/:userID',
    name: 'UserProfile',
    component: UserProfile
  },
  {
    path: '/drops',
    name: 'DropOverview',
    component: Drops,
    props: { selectedView: 'overview' }
  },
  {
    path: '/drops/:dropID',
    name: 'DropDetail',
    component: Drops,
    props: { selectedView: 'detail' }
  },
  {
    path: '/shipments',
    name: 'Shipments',
    component: ShipmentsRouter
  },
  {
    path: '/shipments-new',
    name: 'ShipmentsOverview',
    component: ShipmentsNew,
    props: { selectedView: 'overview' }
  },
  {
    path: '/shipments-new/:shipmentID/schedule',
    name: 'ShipmentsSchedule',
    component: ShipmentsNew,
    props: { selectedView: 'schedule' }
  },
  {
    path: '/shipments-new/:shipmentID/map',
    name: 'ShipmentsMap',
    component: ShipmentsNew,
    props: { selectedView: 'map' }
  },
  {
    path: '/shipments-new/:shipmentID/drops',
    name: 'ShipmentsDrops',
    component: ShipmentsNew,
    meta: { roles: ['Admins', 'Dispatcher'] },
    props: { selectedView: 'drops' }
  },
  {
    path: '/shipments-new/:shipmentID/quote',
    name: 'ShipmentsQuote',
    component: ShipmentsNew,
    props: { selectedView: 'quote' }
  },
  {
    path: '/organizations',
    name: 'OrganizationsOverview',
    component: Organizations,
    props: { selectedView: 'overview' }
  },
  {
    path: '/organizations/:organizationID/fleet',
    name: 'OrganizationsFleet',
    component: Organizations,
    props: { selectedView: 'fleet' }
  },
  {
    path: '/organizations/:organizationID/vehicle-classes',
    name: 'OrganizationsVehicleClasses',
    component: Organizations,
    props: { selectedView: 'vehicleClasses' }
  },
  {
    path: '/organizations/:organizationID/locations',
    name: 'OrganizationsLocations',
    component: Organizations,
    props: { selectedView: 'locations' }
  },
  {
    path: '/organizations/:organizationID/users',
    name: 'OrganizationsUsers',
    component: Organizations,
    props: { selectedView: 'users' }
  },
  {
    path: '/organizations/:organizationID/contacts',
    name: 'OrganizationsContacts',
    component: Organizations,
    props: { selectedView: 'contacts' }
  },
  {
    path: '/orders',
    name: 'OrdersOverview',
    component: OrdersNew,
    props: { selectedView: 'overview' }
  },
  {
    path: '/route-map-test/:coords',
    name: 'RouteMapTest',
    component: MapForRoute
  },
  {
    path: '/shipments-by-day',
    name: 'ShipmentsGroupByDay',
    component: ShipmentsGroupByDay,
  },
  {
    path: '/shipments-by-day/:shipmentID/:shipmentView',
    name: 'ShipmentsGroupByDay',
    component: ShipmentsGroupByDay,
  },
  {
    path: '/browser-detect',
    name: 'BrowserDetect',
    component: BrowserDetect,
  },
  { path: '*', redirect: '/' }
]
const router = new Router({
  routes
})
router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/verify', '/signup', '/browser-detect']
  const authRequired = !publicPages.includes(to.path)
  if (to.path === '/signup' || to.path === '/login') {
    isLoggedIn().then((resolve) => {
      if (!resolve) {
        return next()
      }
      return next('/')
    }).catch((error) => {
      console.error(error)
      return next()
    })
  }
  if (authRequired) {
    routerHelpers.shipmentsByDayRouterStoreInit(to, from)
    routerHelpers.organizationsStoreInit(to, from)
    isLoggedIn().then((resolve) => {
      if (!resolve) {
        return Promise.reject(new Error('Not logged in user'))
      }
      const { roles } = to.meta
      // if route have roles access then get user role from amplify
      if (roles != null) {
        return getLoggedUser()
      }
      return Promise.resolve({ role: 'all' })
    }).then((user) => {
      const { roles } = to.meta
      if (user.role != null) {
        if (user.role === 'all') {
          return next()
        }
      }
      // TODO fixed it better
      const role = user.user['cognito:groups'][0]

      // check if role is in access array if not push to dashboard
      if (roles.indexOf(role) >= 0 || roles.indexOf('all') >= 0) {
        return next()
      } else {
        return next('/')
      }

    }).catch((error) => {
      console.error(error)
      return next('/login')
    })
  }
  return next()
})

export default router
